module.exports = __webpack_public_path__ + "zako insta.png?5c0f5b7225cbe8af75e02eb5b13da9d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zako insta.png
// module id = 129
// module chunks = 0